module.exports = __webpack_public_path__ + "img/quan1.42ef4133.png";